<template>
    <VContent>
        <VContainer fill-height>
            <VLayout
                    style="{max-width:500px;}"
                    align-content-center
                    mx-auto
                    wrap
            >
                <VFlex xs12 sm8 offset-sm2 md5 offset-md4>
                    <BaseCard v-if="!code">
                        <VCardTitle>
                            <v-avatar tile size="40" class="mr-2">
                                <img src="/img/icons/apple-touch-icon-60x60.png" />
                            </v-avatar>
                            Waiting Confirmation
                        </VCardTitle>
                        <VCardText>
                            <p class="indigo--text font-weight-light headline">{{message}}</p>
                            Have the code?
                            <BaseBtn text to="/auth/signup?havecode=true">Enter it here</BaseBtn>
                        </VCardText>
                        <VCardActions>
                            <VSpacer></VSpacer>
                            <BaseBtn to="/">Home</BaseBtn>
                        </VCardActions>
                    </BaseCard>
                    <BaseCard v-else>
                        <VCardTitle>
                            Confirming
                        </VCardTitle>
                        <VCardText
                                pa-0
                                grid-list-xl
                        >
                            <VLayout wrap>
                                <VFlex xs12 class="text-center">
                                    <v-progress-circular
                                            v-if="isLoading"
                                            :size="100"
                                            color="primary"
                                            indeterminate
                                    ></v-progress-circular>
                                    <p v-else-if="!confirmed">
                                        Something went wrong
                                    </p>
                                    <span class="pl-3" v-else>
                                        <h2 class="teal--text">Confirmed</h2>

                                    </span>
                                </VFlex>

                            </VLayout>

                            <VLayout wrap>
                                <VFlex xs12>
                                    <p class="text-center my-2 pa-4" >
                                        <BaseBtn text  to="/auth/signin">
                                            Home
                                        </BaseBtn>
                                    </p>
                                </VFlex>
                            </VLayout>

                        </VCardText>
                    </BaseCard>
                </VFlex>
            </VLayout>
        </VContainer>
    </VContent>
</template>

<script>
  // Utilities
  import {
    mapActions,
    mapMutations
  } from 'vuex'
  import BaseBtn from "../../components/BaseBtn";

  export default {
    components: {BaseBtn},
    data () {
      const data = {
        isLoading: true,
        form: false,
        form2:false,
        firstName: undefined,
        lastName: undefined,
        email: undefined,
        username: undefined,
        password: undefined,
        confirmpassword: undefined,
        code: undefined,
        show: false,
        showConfirm: false,
        enterCode: true,
        confirmed:false,
        message: 'We sent a confirmation link to the email associated with that account. Please click the link to log in.'
      }
      return data
    },
    watch: {
      isReady (val) {
        console.log('is ready: ', val)
        console.log('logged in', this.isLoggedIn)
        if (val && this.isLoggedIn) {
          let em = this
          setTimeout(function () {
            em.$router.push('/authenticated')
          }, 200)
        }
      }
    },
    mounted () {
      let em = this;
      let un = window.localStorage.getItem('username');
      if(un){
          em.username = un
      }
      if(this.$route.query.code==='usernotconfirmedexception'){
        this.message = 'Looks like your account is not confirmed yet. Please click the link we just sent to the' +
            ' email associated with your account. '
      }
      if(this.$route.query.code && this.$route.query.username){
        this.code = this.$route.query.code
        this.username = this.$route.query.username
        this.confirm();
      } else {
        //this.$router.push('/auth/signup')
      }
    },
    methods: {
      ...mapActions('cognito', ['registerUser', 'confirmUser']),
      ...mapMutations(['setSnackbar']),
      confirm () {
        let em = this
        this.isLoading = true
        this.confirmUser({
            username: this.username.trim(),
            code: this.code.trim()
        }).then(() => {
          em.confirmed=true
          window.localStorage.setItem('username',this.username.trim())
          this.setSnackbar({
            type: 'success',
            msg: 'Account confirmed'
          })
          if(this.$route.query.forcereset){
            let em = this
            setTimeout(function(){
              em.$router.push('/auth/signin?redirect=confirmed&forcereset='+em.$route.query.forcereset)
            },1000)
          } else {
            setTimeout(function(){
              em.$router.push('/auth/signin?redirect=confirmed')
            },1000)
          }
          })
          .catch(err => {
            console.log(err)
            if(err.message.includes('Current status is CONFIRMED')){
              em.$router.push('/auth/signin?redirect=confirmed')
            } else {
              this.setSnackbar({
                type: 'error',
                msg: err.message,
                timeout: 10000
              })
            }
          })
          .finally(() => (this.isLoading = false))
      }
    }
  }
</script>
